import { render, staticRenderFns } from "./PostEvaluationAssessmentHistory.vue?vue&type=template&id=f36aa5e8&scoped=true&"
import script from "./PostEvaluationAssessmentHistory.vue?vue&type=script&lang=js&"
export * from "./PostEvaluationAssessmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./PostEvaluationAssessmentHistory.vue?vue&type=style&index=0&id=f36aa5e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36aa5e8",
  null
  
)

export default component.exports